module.exports = __webpack_public_path__ + "static/media/pending.e9dd13ed.svg";